<template>
  <b-tab title="Datos" active>
    <b-row class="mb-3">
      <b-col md="6">
        <campo-tipo-venta :disabled="oferta.id > 0 || esKantan" />
      </b-col>
      <b-col md="6">
        <campo-propietario :disabled="!ofertaBase.unidadNegocioId || ofertaBloqueada" />
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6">
        <campo-unidad-negocio
          :value="ofertaBase.unidadNegocioId"
          @input="cambiarUnidadNegocio"
          :disabled="oferta.id > 0"
        />
      </b-col>
      <b-col md="6">
        <campo-tarifa :disabled="ofertaBloqueada" />
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6"><campo-pais :disabled="!ofertaBase.unidadNegocioId" /></b-col>
      <b-col md="6"><campo-divisa :disabled="ofertaBloqueada" /></b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6">
        <campo-campania :disabled="ofertaBloqueada || !ofertaBase.unidadNegocioId" />
      </b-col>
      <b-col md="6">
        <campo-origen-oferta :disabled="ofertaBloqueada || !ofertaBase.unidadNegocioId" />
      </b-col>
    </b-row>

    <hr />

    <campo-cliente :disabled="campoClienteBloqueado" @clienteCambiado="$refs.descripcion.focus()" />
    <campo-descripcion ref="descripcion" :disabled="ofertaBloqueada || !cliente.id" />

    <hr />

    <b-row class="mb-3">
      <b-col md="6">
        <campo-fecha-oferta :disabled="ofertaBloqueada || !oferta.divisaId" />
      </b-col>
      <b-col md="6">
        <campo-duracion-contrato :disabled="ofertaBloqueada || !oferta.divisaId" v-if="!esKantan" />
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6">
        <campo-fecha-firma :disabled="campoFechaFirmaBloqueado" />
      </b-col>
      <b-col md="6">
        <campo-complejidad-proyecto :disabled="ofertaBloqueada || !oferta.divisaId" v-if="!esKantan" />
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import CampoCampania from "./CamposOferta/CampoCampania";
import CampoCliente from "./CamposOferta/CampoCliente";
import CampoPais from "./CamposOferta/CampoPais";
import CampoDescripcion from "./CamposOferta/CampoDescripcion";
import CampoDivisa from "./CamposOferta/CampoDivisa";
import CampoOrigenOferta from "./CamposOferta/CampoOrigenOferta";
import CampoPropietario from "./CamposOferta/CampoPropietario";
import CampoTarifa from "./CamposOferta/CampoTarifa";
import CampoTipoVenta from "./CamposOferta/CampoTipoVenta";
import CampoUnidadNegocio from "./CamposOferta/CampoUnidadNegocio";
import CampoFechaFirma from "./CamposOferta/CampoFechaFirma";
import CampoFechaOferta from "./CamposOferta/CampoFechaOferta";
import CampoComplejidadProyecto from "./CamposOferta/CampoComplejidadProyecto";
import CampoDuracionContrato from "./CamposOferta/CampoDuracionContrato";

export default {
  components: {
    CampoCliente,
    CampoDescripcion,
    CampoOrigenOferta,
    CampoPais,
    CampoPropietario,
    CampoTipoVenta,
    CampoUnidadNegocio,
    CampoCampania,
    CampoTarifa,
    CampoDivisa,
    CampoFechaOferta,
    CampoComplejidadProyecto,
    CampoDuracionContrato,
    CampoFechaFirma,
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin", "esKantan"]),
    ...mapState(useOfertaFormStore, ["oferta", "ofertaBase", "cliente", "tiposDescuento"]),
    ofertaBloqueada() {
      return this.oferta.caducada == 1 || this.oferta.borrador == 0;
    },
    campoFechaFirmaBloqueado() {
      return this.ofertaBloqueada || this.cliente.id == 0 || this.esNuevaVersion;
    },
    campoClienteBloqueado() {
      return this.ofertaBloqueada || this.oferta.id > 0 || !this.ofertaBase.unidadNegocioId || !this.oferta.campaniaId;
    },
    mostrarFormaPago() {
      return !this.oferta.esPartner || this.esAdmin;
    },
    mostrarDescuentos() {
      return (this.tiposDescuento && !this.oferta.esPartner) || this.esAdmin;
    },
  },
  methods: {
    ...mapState(useOfertaFormStore, ["cambiarUnidadNegocio"]),
  },
};
</script>
